// extracted by mini-css-extract-plugin
export default {"reviewButton":"AddReviewButton_reviewButton__qQ8UC"};